var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbout1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 33,
    width: 13,
    height: 31,
    rx: 2,
    fill: "#FFC717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 96.25C59.6023 96.25 63.3334 92.519 63.3334 87.9167C63.3334 83.3144 59.6023 79.5833 55 79.5833C50.3976 79.5833 46.6667 83.3144 46.6667 87.9167C46.6667 92.519 50.3976 96.25 55 96.25Z",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.917 96.25C107.519 96.25 111.25 92.519 111.25 87.9167C111.25 83.3144 107.519 79.5833 102.917 79.5833C98.3144 79.5833 94.5833 83.3144 94.5833 87.9167C94.5833 92.519 98.3144 96.25 102.917 96.25Z",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6667 87.9167H34.1667V37.9167H94.5834V87.9167H63.3334",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5833 87.9167V52.5H112.44L125.833 70.2083V87.9167H112.94",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73723 41H26.2628C27.7591 41 28 40.32 28 39.5C28 38.68 27.7591 38 26.2628 38H6.73723C5.24088 38 5 38.68 5 39.5C5 40.32 5.24088 41 6.73723 41Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.00512
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1975 47H10.8025C9.27046 47 9 47.68 9 48.5C9 49.32 9.27046 50 10.8025 50H26.1975C27.7295 50 28 49.32 28 48.5C28 47.68 27.7669 47 26.1975 47Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.00512
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2561 56H16.7439C15.2439 56 15 56.68 15 57.5C15 58.32 15.2439 59 16.7439 59H26.2561C27.7561 59 28 58.32 28 57.5C28 56.68 27.7927 56 26.2561 56Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.00512
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1875 65H22.8125C21.275 65 21 65.68 21 66.5C21 67.32 21.275 68 22.8125 68H26.1875C27.725 68 28 67.32 28 66.5C28 65.68 27.7625 65 26.1875 65Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.00512
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout1);
export default __webpack_public_path__ + "static/media/about-1.b2961a6138979dfa85a17d2f3badd799.svg";
export { ForwardRef as ReactComponent };